import { GraphicElement } from './GraphicElement';
export class Group extends GraphicElement {
    constructor(engine, uuid, pos, size, options, scale, rotation) {
        super(engine, uuid, pos, size, scale, rotation, options);
        this._colorGroups = [];
    }
    get colorGroups() {
        return this._colorGroups;
    }
    set colorGroups(colorGroups) {
        this._colorGroups = colorGroups;
    }
    addOrReplaceColorGroup(colorGroup) {
        const group = this.colorGroups.find((group) => group.id == colorGroup.id);
        if (group) {
            group.color = colorGroup.color;
        } else {
            this._colorGroups.push(colorGroup);
        }
    }
}
